import { EmpresaAprovacaoDetalhe } from '../../types/empresaApproval';

export function buildEmpresaApprovalIssues(empresa: EmpresaAprovacaoDetalhe): string[] {
  const issues: string[] = [];
  if (!empresa.email && !empresa.telefone) issues.push('Nenhum contato cadastrado.');
  if (!empresa.endereco || !empresa.municipio || !empresa.uf) issues.push('Localização cadastral incompleta.');
  if (!empresa.papeis.some((item) => item.status === 'ativo')) issues.push('Nenhum papel operacional ativo.');
  if (!empresa.representantes.some((item) => item.status === 'ativo')) issues.push('Nenhum representante ativo.');
  if (empresa.documentos.length === 0) issues.push('Nenhum documento oficial cadastrado.');
  const pendingDocuments = empresa.documentos.filter((item) => ['pendente', 'em_validacao'].includes(item.statusValidacao)).length;
  if (pendingDocuments > 0) issues.push(`${pendingDocuments} documento(s) ainda aguardam validação documental independente.`);
  const invalidDocuments = empresa.documentos.filter((item) => ['invalido', 'vencido', 'incompativel_com_escopo', 'nao_localizado_no_orgao'].includes(item.statusValidacao)).length;
  if (invalidDocuments > 0) issues.push(`${invalidDocuments} documento(s) possuem impedimento documental.`);
  return issues;
}
